export const ctaLabels = {
    "en": {
        "buttonLabel": "Find my home",
        "subheading": "Find your new home",
        "heading": "Start living today"
    },
    "fr": {
        "buttonLabel": "Trouver ma maison",
        "subheading": "Trouvez votre nouveau logement",
        "heading": "Commencez à vivre dès aujourd'hui"
    }
    ,
    "es": {
        "buttonLabel": "Encontrar mi hogar",
        "subheading": "Encuentra tu nuevo hogar",
        "heading": "Empieza a vivir hoy"
    }

}